<template>
  <div class="">
    <section>
      <div class="container-lg p-0">
      <b-breadcrumb class="m-0 bg-transparent">
        <b-breadcrumb-item :to="{name:'proOverview'}">
          <b-icon icon="house-fill" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
          商品管理
        </b-breadcrumb-item>
        <b-breadcrumb-item href="#foo" active>上架商品</b-breadcrumb-item>
      </b-breadcrumb>
      </div>
    </section>
    <div class="container-lg pt-1 p-0 custom-shadow border-top">
      <div class="row no-gutters">
        <div class="col-12">
          <div class="d-flex justify-content-center">
            <b-card border-variant="light" bg-variant="transparent"
            body-border-variant="white" body-bg-variant="white" body-class="p-0"
            header-border-variant="white" header-bg-variant="transparent" header-class="px-0 pt-2 pb-0"
            footer-border-variant="white" footer-bg-variant="white" 
            class="w-100">
              <template v-slot:header>
                <ul class="nav nav-tabs nav-pills flex-nowrap overflow-x-auto">
                  <li class="nav-item text-nowrap ml-3" v-for='item in tagslist' :key='"PT__"+item.pagename'>
                    <a
                      class="nav-link"
                      :class="{active:pageRoute === item.pagename}"
                      @click='changeTagsPage(item.pagename)'
                    >{{item.name}}</a>
                  </li>

                </ul>
              </template>
              <b-card-body>
                <div class="d-flex flex-fill">
                  <component :is="imporpage" :data.sync="productdata" :pagename="pageRoute"></component>
                </div>
              </b-card-body>
              <template v-slot:footer>
                <div class="d-flex justify-content-end">
                  <button type="button" class="btn btn-sm btn-outline-danger">不儲存關閉</button>
                  <button type="button" class="btn btn-sm btn-outline-warning ml-3">暫存不上架</button>
                  <button type="button" class="btn btn-sm btn-outline-primary ml-3" @click='savePro()'>儲存</button>
                </div>
              </template>
            </b-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import ctrl from '@/js/InsertProduct.js';
  export default ctrl;
</script>
<style lang="scss">
.card {
  border-radius: 5px;
}
</style>
